import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";

const Autocomplete = ({
  id,
  options,
  label,
  filterKey,
  placeholder,
  onSelect,
  onChange,
  multiple,
  selected,
  defaultSelected,
  className,
  disabled = false,
  clearButton = true,
}: {
  id: string;
  options: any;
  label: string;
  filterKey: string;
  placeholder: string;
  onSelect?: Function;
  onChange?: Function;
  multiple?: boolean;
  selected?: any[];
  defaultSelected?: any[];
  className?: string;
  disabled?: boolean;
  clearButton?: boolean;
}) => {
  const [selections, setSelections] = useState<any[]>([]);
  const handleChange = (val: any) => {
    onSelect && onSelect(val);
    onChange && onChange(val);
    setSelections(val);
  };
  useEffect(() => {
    if (selected) {
      setSelections(selected);
    }
  }, [selected]);
  return (
    <>
      <Form.Group className={className ? className : ""}>
        {label && <Form.Label htmlFor={id}>{label}</Form.Label>}
        <Typeahead
          disabled={disabled}
          id={id}
          labelKey={filterKey}
          onChange={handleChange}
          multiple={multiple}
          options={options}
          placeholder={placeholder}
          selected={selections}
          defaultSelected={defaultSelected}
          clearButton={clearButton}
        />
      </Form.Group>
    </>
  );
};

export default Autocomplete;
